import React from 'react';
import { Popconfirm } from 'antd';
import type { PopconfirmProps } from 'antd';

// ─── 타입 ─────────────────────────────────────────────────────────────────────

export interface AppPopconfirmProps extends Omit<PopconfirmProps, 'okText' | 'cancelText' | 'okButtonProps'> {
  /**
   * 확인 버튼 텍스트.
   * @default '삭제'
   */
  okText?: string;
  /**
   * 취소 버튼 텍스트.
   * @default '취소'
   */
  cancelText?: string;
  /**
   * 확인 버튼을 danger 스타일로 표시할지 여부.
   * @default true
   */
  danger?: boolean;
}

// ─── AppPopconfirm ────────────────────────────────────────────────────────────

/**
 * 프로젝트 공통 삭제 확인 팝오버.
 *
 * 삭제 액션에 쓰이는 Popconfirm 의 반복 옵션을 기본값으로 고정한다:
 *   - okText="삭제"
 *   - cancelText="취소"
 *   - okButtonProps={{ danger: true }}
 *
 * 사용 예:
 *   // 기본 삭제 확인
 *   <AppPopconfirm title="정말 삭제하시겠습니까?" onConfirm={() => handleDelete(id)}>
 *     <AppButton variant="text" size="sm" icon={<DeleteOutlined />} iconOnly />
 *   </AppPopconfirm>
 *
 *   // 커스텀 문구가 필요한 경우
 *   <AppPopconfirm
 *     title={`선택한 ${count}건을 삭제하시겠습니까?`}
 *     okText="일괄 삭제"
 *     onConfirm={handleBulkDelete}
 *   >
 *     <AppButton variant="ghost-danger">선택 삭제</AppButton>
 *   </AppPopconfirm>
 */
export const AppPopconfirm: React.FC<AppPopconfirmProps> = ({
  okText = '삭제',
  cancelText = '취소',
  danger = true,
  children,
  ...rest
}) => (
  <Popconfirm
    okText={okText}
    cancelText={cancelText}
    okButtonProps={{ danger }}
    {...rest}
  >
    {children}
  </Popconfirm>
);